import React, {useEffect, useState} from "react";
import {Navigate} from 'react-router-dom';
import {__DEFAULT_FORM_SETTINGS, activeFormPanel, changeFormsJsKey, mrbgStore, newFormsSetting, updateVars} from './mrbg/mrbgRedux/index.js';
import {formsJson} from '../mrbgLib/formsJson.js';
import mrbgS2S from '../mrbgLib/mrbgS2S.js';
import MrbgLoader from './mrbg/MrbgLoader.jsx';
import MrbgPanel from './mrbg/MrbgPanel.jsx';
import MrbgLogin from './mrbg/MrbgLogin.jsx';
import MP_mainStyle from './../static/css/MP_main.module.css';

function Panel(){
	const
		[tokenInfo, setTokenInfo        ] = useState(mrbgStore.getState().__TK?.EP),
		[failedMsg, setFailedMsg        ] = useState(undefined),
		[formsJsKey,setFormsJsKey       ] = useState(mrbgStore.getState().formsJsKey),
		[readySettings,setReadySettings ] = useState(mrbgStore.getState().mrbgVars?.readySettings||{}),
		[formsList,setFormsList         ] = useState(mrbgStore.getState().mrbgVars.formsList||[]),

		changeFormGroup = function(){
			var
				frmLi = new Set(formsList),
				fs = {},
				readySettings = {};

			console.log(formsList)
			if( formsJson[formsJsKey] ){
				Object.keys(formsJson[formsJsKey]).forEach(origin=>{
					if( Object.hasOwn(formsJson[formsJsKey][origin],'forms') ){
						Object.keys(formsJson[formsJsKey][origin].forms).map(formID=>{
							if( frmLi.has(formID) ){
								var prt = {};
								if( formsJson[formsJsKey][origin].forms[formID].parts )
									for( let pn in formsJson[formsJsKey][origin].forms[formID].parts )
										prt[pn] = {
											defaultR: formsJson[formsJsKey][origin].forms[formID].parts[pn].repeat,
											currentR: formsJson[formsJsKey][origin].forms[formID].parts[pn].repeat
										}
								fs[formID] = {...__DEFAULT_FORM_SETTINGS,partsLen:{...prt}};
								readySettings[formID] = origin;
							}
						})
					}
					if( Object.hasOwn(formsJson[formsJsKey][origin],'tables') ){
						Object.keys(formsJson[formsJsKey][origin].tables).map(formID=>{
							if( frmLi.has(formID) ){
								fs[formID] = {...__DEFAULT_FORM_SETTINGS};
								readySettings[formID] = origin;
							}
						})
					}
					if( !Object.hasOwn(formsJson[formsJsKey][origin],'forms') && !Object.hasOwn(formsJson[formsJsKey][origin],'tables'))
						readySettings[origin] = origin;
				})
			}
			if( JSON.stringify(fs)!==JSON.stringify(mrbgStore.getState().formsSettings) ){
				mrbgStore.dispatch(newFormsSetting(fs))
				mrbgStore.dispatch(updateVars({readySettings}))
			}
		};

	useEffect(() => {
		const unsubscribe = mrbgStore.subscribe(() => {
			setTokenInfo    ( mrbgStore.getState().__TK?.EP );
			setFormsJsKey   ( mrbgStore.getState().formsJsKey );
			setReadySettings( mrbgStore.getState().mrbgVars?.readySettings||{} );
			setFormsList    ( mrbgStore.getState().mrbgVars.formsList||[]);
		});
		return () => unsubscribe();
	}, []);
	useEffect(()=> {
		if( formsJsKey==='login' ){
			mrbgStore.dispatch(updateVars({formsList:Object.keys(formsJson.login.emp.forms)}))
			mrbgStore.dispatch(activeFormPanel('signIn'))
		}
	},[formsJsKey])
	useEffect(() =>{
		changeFormGroup();
	}, [formsList,formsJsKey]);

	if( tokenInfo?.id===undefined ){
		if( failedMsg===undefined )
			mrbgS2S(null, null, 'pan', 'load')
				.then(x => {
					typeof x === 'object'?
						setFailedMsg( undefined ):
						setFailedMsg( x )
				})
				.catch(() => setFailedMsg('Error loading data'));

		if( failedMsg ){
			return <div dangerouslySetInnerHTML={{ __html: failedMsg }} />
		}
		else
			return <MrbgLoader />
	}
	else if( tokenInfo.id && tokenInfo.PR ){
		if( !['EP','AP'].includes(formsJsKey) ){
			mrbgStore.dispatch(changeFormsJsKey('EP'))
			if( mrbgStore.getState().activeForms[0]==='signIn' )
				mrbgStore.dispatch(activeFormPanel(['3dayChart__TLFrame','todaySession__TFFrame']))
		}
		return (
			<>
				<Navigate replace to={`/panel`}/>
				<MrbgPanel {...{MP_mainStyle,formsJsKey,readySettings}}/>
			</>
		);
	}
	else{
		if( formsJsKey!=='login' ){
			mrbgStore.dispatch(changeFormsJsKey('login'))
			if( mrbgStore.getState().activeForms[0]!=='signIn' )
				mrbgStore.dispatch(activeFormPanel('signIn'))
		}
		return(
			<>
				<Navigate replace to={`/login`}/>
				<MrbgLogin {...{readySettings}}/>
			</>
		);
	}
}

export default Panel;